module.exports = __webpack_public_path__ + "img/motivauswahl_1.4539ffb1.jpg";